import moment from "moment";

export function checkNull2String(val, def = "") {
    return val === undefined ? def : val
}

export function checkNull2Int(val, def = 0) {
    return val === undefined ? def : val
}

export function checkNull2Json(val, def = {}) {
    return val === undefined ? def : val
}


export function uuid(len, radix) {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
    } else {
        // rfc4122, version 4 form
        var r;

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return uuid.join('');
}

export function getKey({len = 10, radix=64}){
    return uuid(len, radix)
}

/**
 * 取得 Array 中的名稱
 * @param {*} items 
 * @param {*} val 
 */
export function getItemsInfo({ items, val, key = "val", name = "name", optionN, debug = false }) {
    if (optionN === undefined) {
        optionN = [{ ov: "k", on: name }]
    }
    try {
        if (items === undefined) {
            return ""
        }
        if (val === "") {
            return ""
        }
        if (debug) {
            // console.log(items)
            // console.log(val)
            // console.log(key)
            // console.log(name)
            //console.log(typeof(val))
            // var filterEmpty = 
            items.filter((defaultItem) => {
                var v = defaultItem[key]
                if (typeof (val) === "string") {
                    v += ""
                }
                return (val === v)
            })
            //console.log(filterEmpty)
        }
        var item = items.filter((defaultItem) => {
            var v = defaultItem[key]
            if (typeof (val) === "string") {
                v += ""
            }
            return (val === v)
        })
        item = item[0]
        if (item === undefined)
            return "未選擇"
        if (Object.keys(item).length !== 0) {
            return getOptionName(item, optionN)
        }
        return ""
    } catch (error) {
        console.log(error)
        return ""
    }
}

/**
 * 取得下拉選單內的文字
 * @param {*} item 
 * @param {*} optionName 
 */
export function getOptionName(item, optionName) {
    var name = ""
    optionName.map((on) => {
        //console.log(on.ov)
        //console.log(on.on)
        switch (on.ov) {
            case "n":
                name += on.on
                //console.log(on.on)
                break;
            case "k":
                if(typeof item[on.on] === 'number'){
                    name += Number(item[on.on]).toLocaleString('en-US')
                }else{
                    name += item[on.on]
                }
                //console.log(item[on.on])
                break;
            default:
                break;
        }
    })
    // console.log(optionName)
    // console.log(item)
    // console.log(name)
    return name
}


/*判斷輸入是否為合法的手機號碼*/
export function checkNum(num) {

    var mobileReg = /^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i;
    var phoneReg = /^0\d{2,3}-?\d{7,8}$/;

    if (!mobileReg.test(num) && !phoneReg.test(num)) {
        return false
    }
    return true;
}

//檢查身份証號
export function checkID(id) {
    var tab = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
    var A1 = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3];
    var A2 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0, 1, 2, 3, 4, 5];
    var Mx = [9, 8, 7, 6, 5, 4, 3, 2, 1, 1];

    if (id.length !== 10) return false;
    var i = tab.indexOf(id.charAt(0));
    if (i === -1) return false;
    var sum = A1[i] + A2[i] * 9;

    for (i = 1; i < 10; i++) {
        var v = parseInt(id.charAt(i));
        if (isNaN(v)) return false;
        sum = sum + v * Mx[i];
    }
    if (sum % 10 !== 0) return false;
    return true;
}

export function getOnlyDate() {
    // var date = new Date();
    //console.log(date);  
    return moment(new Date()).format('YYYY-MM-DD')
    //return date.pattern("yyyy-MM-dd");
}
export function getOnlyDateSlash() {
    // var date = new Date();
    //console.log(date);  
    return moment(new Date()).format('YYYY/MM/DD')
    //return date.pattern("yyyy-MM-dd");
}

export function sortBy (filed, rev, primer) {
    rev = (rev) ? -1 : 1;
    return function (a, b) {
        a = a[filed];
        b = b[filed];
        if (typeof (primer) != 'undefined') {
            a = primer(a);
            b = primer(b);
        }
        if (a < b) { return rev * -1; }
        if (a > b) { return rev * 1; }
        return 1;
    }
};